<template>
  <div class="form-contact">
    <b-form @submit="sendMail">
      <div class="section">
        <b-row>
          <b-col sm="6">
            <label class="mr-sm-2" for="name">Nombre*</label>
            <b-form-input
              id="name"
              v-model="email.name"
              type="text"
              placeholder="Nombre"
              trim
              required
            ></b-form-input>
          </b-col>
          <b-col sm="6">
            <label class="mr-sm-2" for="email">Email*</label>
            <b-form-input
              id="email"
              v-model="email.email"
              type="email"
              placeholder="Email"
              required
              trim
            ></b-form-input>
          </b-col>
          <b-col sm="12">
            <label class="mr-sm-2" for="subject">Asunto*</label>
            <b-form-input
              id="subject"
              v-model="email.subject"
              type="text"
              placeholder="Asunto"
              trim
              required
            ></b-form-input>
          </b-col>
          <b-col>
            <label class="mr-sm-2" for="message">Mensaje*</label>
            <b-form-textarea
              id="message"
              v-model="email.message"
              placeholder="Escriba aquí el mensaje..."
              rows="3"
              required
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
      <div class="section">
        <b-row>
          <b-col>
            <b-form-checkbox
              style="float:left;"
              id="accept-terms"
              v-model="email.terms"
              name="accept-terms"
              value="accepted"
              unchecked-value="not_accepted"
              required
            >Acepto los términos de servicio y condiciones</b-form-checkbox>

            <router-link
              style="float:left;margin-left:6px;"
              to="/lopd"
              target="_blank"
            >Más información</router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>* Campos Obligatorios</p>
          </b-col>
        </b-row>
      </div>
      <div class="button-container">
        <b-row>
          <b-col>
            <b-button type="submit" class="btn btn-send btn-primary">
              <template v-if="sending">
                <b-spinner style="width: 1.3rem; height: 1.3rem;color:white;" label="Large Spinner"></b-spinner>
              </template>
              <template v-else>Enviar</template>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-form>
    <div v-if="successMessage !== ''" class="result-displayer-success">{{successMessage}}</div>
    <div v-if="errorMessage !==''" class="result-displayer-error">{{errorMessage}}</div>
  </div>
</template>

<script>
import MailRepository from "@/repositories/MailRepository";
import MessageRepository from "@/repositories/MessageRepository";

export default {
  name: "FormContact",
  props: {
    property: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      sending: false,
      email: {},
      successMessage: "",
      errorMessage: ""
    };
  },
  methods: {
    async sendMail(event) {
      this.saveMessage();
      this.sending = true;
      event.preventDefault();

      const data = new FormData()
      data.append('title',  this.email.subject)
      data.append('reply_to',  this.email.email)
      data.append('msg',  'Mail: ' + this.email.email + '<br/>Nombre: ' + this.email.name + '<br/>Propiedad: ' + this.property + '<br/>Mensaje: ' + this.email.message)

      MailRepository.sendMail(data)
        .then( ({data}) => {
          if ( data.status == "OK") {
            this.showSuccess("El mensaje ha sido enviado correctamente.");
            this.email = {};
          } else {
            this.showError(
              "Se ha producido un error en el envío del correo. Si persiste contacte directamente mediante el correo: info@versadainmobiliaria.com"
            );
          }
        })
        .catch(() => {
           this.showError(
              "Se ha producido un error en el envío del correo. Si persiste contacte directamente mediante el correo: info@versadainmobiliaria.com"
            );
        });

      this.sending = false;
    },
    async saveMessage() {
      const data = {
        email: this.email.email,
        subject: this.email.subject,
        property: this.property == '' ? null : this.property,
        msg: 'Nombre: ' + this.email.name + '<br/>Mensaje: ' + this.email.message
      };
      await MessageRepository.saveMessage(data);
    },
    showSuccess(message) {
      this.successMessage = message;
      setTimeout(() => {
        this.errorMessage = "";
        this.successMessage = "";
      }, 5000);
    },
    showError(message) {
      this.errorMessage = message;
      setTimeout(() => {
        this.errorMessage = "";
        this.successMessage = "";
      }, 20000);
    }
  }
};
</script>

<style lang="scss">
.button-container {
  margin-top: 20px;
}
.btn-send.btn-primary {
  background-color: #0085ca;
  color: #fff;

  width: 120px;
  border: 2px solid #0085ca;

  &:hover {
    color: #0085ca;
    background-color: #fff;
  }
}
.result-displayer-success {
  margin-top: 20px;
  background-color: #00800096;
  color: white;
  border-radius: 5px;
  padding: 10px;
}
.result-displayer-error {
  margin-top: 20px;
  background-color: #e55353c2;
  color: white;
  border-radius: 5px;
  padding: 10px;
}
.section {
  margin-top: 10px;
}
.form-contact {
  margin-bottom: 30px;
}
</style>
